import dayjs, { type Dayjs } from 'dayjs';

/**
 * @returns Period range corresponding to provided year
 */
export const getPeriodFromYear = (year: number, timeWindowShift = 0): { dateFrom: Dayjs; dateTo: Dayjs } => {
  const dateFrom = dayjs().year(year).add(timeWindowShift, 'year').startOf('year');
  const dateTo = dayjs().year(year).add(timeWindowShift, 'year').endOf('year');

  return { dateFrom, dateTo };
};
